<template>
  <div>
    <back-button />
    <page-header>Товары «{{ partner.name }}»</page-header>

    <v-row>
      <v-col>
        <v-progress-circular
          v-if="loadingCategories"
          class="ml-1"
          indeterminate
          size="32"
        ></v-progress-circular>
        <v-select
          v-else
          clearable
          :items="categories"
          filled
          label="Выберите категорию"
          item-text="name"
          item-value="id"
          v-model="category"
        ></v-select>
      </v-col>
      <v-col>
        <v-text-field
          filled
          clearable
          v-model="itemId"
          label="Поиск по id"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          filled
          clearable
          v-model="itemName"
          label="Поиск по названию"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-btn @click="getItems()"><v-icon>mdi-refresh</v-icon> Обновить список</v-btn>
      </v-col>
    </v-row>

    <v-data-table
      v-model="selectedItems"
      item-key="id"
      show-select
      :headers="computedHeaders"
      :items="items"
      class="elevation-1 mb-60"
      :loading="loading"
      :options.sync="options"
      :server-items-length="total"
      disable-sort
      :footer-props="footerProps"
    >
      <template v-slot:item.active="{ item }">
        <v-icon :color="item.active ? 'green' : 'red'"
          >mdi-circle-medium</v-icon
        >
      </template>
      <template v-slot:item.pictureUrl="{ item }">
        <v-img
          width="64"
          height="64"
          :src="item.pictureUrl"
          v-if="item.pictureUrl"
        />
      </template>
      <template v-slot:item.category="{ item }">
        {{ printCategories(item) }}
      </template>
      <template v-slot:item.sort="{ item }">
        <v-text-field
          v-model="item.currentSort"
          @change="updateSort(item)"
          type="number"
        ></v-text-field>
      </template>
      <template v-slot:item.delete="{ item }">
        <v-icon @click="edit(item)">mdi-pencil</v-icon>
        <!--<v-icon @click="remove(item.id)">mdi-trash-can-outline</v-icon>-->
      </template>
      <template v-slot:item.price="{ item }">
        <v-icon v-if="item.price === -1" @click="showPrices(item.prices)">mdi-eye</v-icon>
        <span v-else>{{ item.price }}</span>
      </template>
    </v-data-table>

    <v-row
      v-if="selectedItems.length"
      style="position:sticky;bottom:0;background:#fff;box-shadow:0 0 10px #ccc"
    >
      <v-col cols="2">
        <div class="mt-4">С отмеченными:</div>
      </v-col>
      <v-col cols="6" class="d-flex">
        <v-select
          hide-details
          class="mr-4"
          filled
          label="Выберите категорию"
          :items="categories"
          item-text="name"
          item-value="id"
          v-model="categoryToMoveTo"
          multiple
        />
        <v-btn
          color="primary"
          class="mt-2"
          :disabled="categoryToMoveTo == null || loading"
          @click="massMove()"
          >Перенести ({{ selectedItems.length }})</v-btn
        >
      </v-col>
      <v-col cols="4">
        <v-btn
          @click="massDelete()"
          :disabled="loading"
          color="red"
          class="mt-2"
          >Удалить ({{ selectedItems.length }})</v-btn
        >
      </v-col>
    </v-row>

    <v-dialog v-model="editDialog" max-width="600px" :key="activeItem.id">
      <goods-form
        :item="activeItem"
        @submit="editGood"
        @close="editDialog = !editDialog"
        :categories="categories"
      />
      <v-progress-linear v-if="loadingItem" indeterminate />
    </v-dialog>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="red" dark bottom right fixed fab v-bind="attrs" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </template>

      <goods-form
        @submit="addGood"
        @close="dialog = !dialog"
        :categories="categories"
        :key="formKey"
      />
      <v-progress-linear v-if="loadingItem" indeterminate />
    </v-dialog>

    <v-dialog v-model="priceDialog" max-width="600px">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Регион
              </th>
              <th class="text-left">
                Цена
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in currentPrices"
              :key="item.region"
            >
              <td>{{ item.region }}</td>
              <td>{{ item.value }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-dialog>
  </div>
</template>

<script>
import api from "../api";
import axios from "axios";
import store from "../store";
import GoodsForm from "../components/GoodsForm";
import BackButton from "../components/BackButton";
import PageHeader from "../components/PageHeader";

export default {
  name: "partner-goods",
  components: {
    PageHeader,
    BackButton,
    GoodsForm
  },
  data() {
    return {
      footerProps: {
        "items-per-page-options": [50, 150, 200]
      },
      priceDialog: false,
      currentPrices: [],
      formKey: 0,
      activeItem: {},
      categories: [],
      dialog: false,
      editDialog: false,
      loading: false,
      loadingItem: false,
      loadingCategories: false,
      options: {
        sortBy: ["sort"]
      },
      category: null,
      itemId: null,
      itemName: null,
      selectedItems: [],
      partner: {},
      items: [],
      total: 0,
      categoryToMoveTo: null,
      headers: [
        {
          text: "",
          value: "active"
        },
        {
          text: "",
          value: "pictureUrl"
        },
        {
          text: "Товар",
          value: "name"
        },
        {
          text: "ID у партнёра",
          value: "externalId"
        },
        {
          text: "Цена",
          value: "price"
        },
        {
          text: "Валюта",
          value: "currency"
        },
        {
          text: "Категория",
          value: "category"
        },
        {
          text: "Порядок",
          value: "sort"
        },
        {
          text: "",
          value: "delete"
        }
      ]
    };
  },
  computed: {
    id() {
      return Number(this.$route.params.id);
    },
    goods() {
      let goods = [];
      this.selectedItems.forEach(item => {
        goods.push(item.id);
      });
      return goods;
    },
    computedHeaders() {
      if (!this.category) return this.headers.filter(f => f.value != "sort");
      else return this.headers;
    }
  },
  watch: {
    itemId: {
      handler() {
        this.getItems();
      }
    },
    itemName: {
      handler() {
        this.getItems();
      }
    },
    category: {
      handler() {
        this.getItems();
      }
    },
    options: {
      handler() {
        this.getItems();
      }
    }
  },
  methods: {
    showPrices(prices) {
      this.currentPrices = prices;
      this.priceDialog = true;
    },
    printCategories(item) {
      let categories = item.category.map(categoryId => {
        return this.categories.find(category => {
          return category.id == categoryId;
        }).name;
      });
      return categories.join(", ");
    },
    getSortValue(item) {
      let sort = item.sort.filter(obj => obj.category == this.category);
      return sort[0].value;
    },
    edit(item) {
      this.activeItem = item;
      this.editDialog = true;
    },
    massMove() {
      this.loading = true;
      axios
        .post(api.moveGoods(this.id), {
          goods: this.goods,
          category: this.categoryToMoveTo
        })
        .then(() => {
          this.getItems();
          this.selectedItems = [];
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Товары перенесены";
        })
        .finally(() => {
          this.loading = false;
        });
    },
    massDelete() {
      if (confirm("Вы уверены?")) {
        this.loading = true;
        axios
          .post(api.deleteGoods(this.id), {
            goods: this.goods
          })
          .then(() => {
            this.getItems();
            this.selectedItems = [];
            store.snackbar = true;
            store.snackbarSuccess = true;
            store.snackbarMessage = "Товары удалены";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    updateSort(item) {
      this.loading = true;
      axios
        .post(`${api.goods(this.id)}/${item.id}/sort`, {
          category: this.category,
          sort: item.currentSort
        })
        .then(() => {
          item.sort = item.currentSort;
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Изменения применены";
        })
        .finally(() => {
          this.loading = false;
        });
      this.loading = false;
    },
    remove(id) {
      this.loading = true;
      axios
        .delete(`${api.goods(this.id)}/${id}`)
        .then(() => {
          this.getItems();
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Товар удалён";
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editGood(data) {
      this.loadingItem = true;
      axios
        .put(`${api.goods(this.id)}/${this.activeItem.id}`, data)
        .then(() => {
          this.editDialog = false;
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Товар обновлён";
          this.getItems();
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loadingItem = false;
        });
    },
    addGood(data) {
      let item = {
        category: data.category || [this.category],
        externalId: data.externalId,
        sort: 100,
        name: data.name
      };

      this.loadingItem = true;
      axios
        .post(api.goods(this.id), item)
        .then(() => {
          this.dialog = false;
          this.formKey++;
          store.snackbar = true;
          store.snackbarSuccess = true;
          store.snackbarMessage = "Товар добавлен";
          this.getItems();
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loadingItem = false;
        });
    },
    getItems() {
      this.loading = true;
      axios
        .get(api.goods(this.id), {
          params: {
            "per-page":
              this.options.itemsPerPage > 0 ? this.options.itemsPerPage : 1000,
            page: this.options.page,
            category: this.category ? this.category : "",
            external_id: this.itemId,
            name: this.itemName
          }
        })
        .then(resp => {
          this.items = resp.data.sort((a, b) => a.sort > b.sort);
          if (this.category) {
            this.items.forEach(item => {
              item.currentSort = this.getSortValue(item);
            });
          }
          this.total = Number(resp.headers["x-pagination-total-count"]);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getPartner() {
      axios.get(`${api.partners}/${this.id}`).then(resp => {
        this.partner = resp.data;
      });
    },
    getCategories() {
      this.loadingCategories = true;
      axios
        .get(api.categories)
        .then(resp => {
          this.categories = resp.data;
        })
        .catch(err => {
          store.snackbar = true;
          store.snackbarSuccess = false;
          store.snackbarMessage = err.message;
        })
        .finally(() => {
          this.loadingCategories = false;
        });
    }
  },
  mounted() {
    this.getCategories();
    this.getPartner();
  }
};
</script>

<style></style>
